import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import '../styles/Regalos.css';

const VACIO = { nombre_local: '', categoria: 'Café', descuento: '', descripcion: '', direccion: '', condiciones: '', patrocinado: false, activo: true };

// Edad a partir de 'AAAA-MM-DD'
const edad = (f) => {
  if (!f) return null;
  const [a, m, d] = f.split('-').map(Number), h = new Date();
  return h.getFullYear() - a - ((h.getMonth() + 1 < m || (h.getMonth() + 1 === m && h.getDate() < d)) ? 1 : 0);
};

// Locales que se registraron en el panel de Cupido Descuentos (/descuentos): aprobar, rechazar, pausar
function Locales({ success, error }) {
  const [locales, setLocales] = useState(null);
  const load = useCallback(() => api.adminComercios()
    .then(d => setLocales((d.comercios || []).filter(c => c.en_descuentos)))
    .catch(e => error(e.message || 'Error cargando locales.')), [error]);
  useEffect(() => { load(); }, [load]);
  const run = async (fn, msg) => { try { await fn(); if (msg) success(msg); load(); } catch (e) { error(e.message); } };
  const acceso = (c) => run(async () => {
    const { url } = await api.adminAccesoComercio(c.id);
    try { await navigator.clipboard.writeText(url); } catch { /* sin portapapeles */ }
  }, 'Le mandamos el acceso por correo (y quedó copiado el enlace).');

  if (!locales) return <p className="regalos-empty">Cargando locales…</p>;
  return (
    <div style={{ marginBottom: 24 }}>
      <h3 className="regalos-section-title">🏪 Locales adheridos</h3>
      {locales.length === 0 ? <p className="regalos-empty">Todavía no se registró ningún local en /descuentos.</p> : locales.map(c => (
        <div key={c.id} className="comercio-card" style={c.activo ? {} : { opacity: 0.6 }}>
          <div className="regalo-head">
            <div>
              {c.logo_path && <img src={c.logo_path} alt="" className="comercio-logo" style={{ verticalAlign: 'middle', marginRight: 8 }} />}
              <span className="regalo-name">{c.nombre}</span>{' '}
              {c.en_delivery ? <span className="badge badge-gris">🛵 También en Cupido Delivery</span> : null}{' '}
              {c.estado === 'pendiente' && <span className="badge badge-dorado">⏳ Pendiente de aprobación</span>}
              {c.estado === 'rechazado' && <span className="badge badge-rojo">Rechazado</span>}
              {!c.activo && <span className="badge badge-gris">Pausado</span>}
              <div className="regalo-detail">
                {c.email}{c.telefono ? ` · ${c.telefono}` : ''}{c.descripcion ? ` · ${c.descripcion}` : ''}
                {' · '}{c.fecha_nacimiento ? `Responsable de ${edad(c.fecha_nacimiento)} años` : '⚠️ Sin fecha de nacimiento'}
                {c.google_id ? ' · Ingresa con Google' : ''}
                {c.destacado_hasta && new Date(c.destacado_hasta.replace(' ', 'T') + 'Z') > new Date() ? ` · ⭐ Destacado hasta ${new Date(c.destacado_hasta.replace(' ', 'T') + 'Z').toLocaleDateString('es-AR')}` : ''}
                {c.mp_preapproval_estado === 'authorized' ? ' · 💳 Suscripción mensual activa' : ''}
              </div>
            </div>
            <div className="admin-actions">
              {c.estado !== 'aprobado' && <button className="btn btn-primary btn-sm" onClick={() => run(() => api.adminEstadoComercio(c.id, 'aprobado'), 'Local aprobado. Le avisamos por correo.')}>✅ Aprobar</button>}
              {c.estado === 'pendiente' && <button className="btn btn-outline btn-sm" onClick={() => window.confirm(`¿Rechazar a ${c.nombre}?`) && run(() => api.adminEstadoComercio(c.id, 'rechazado'), 'Solicitud rechazada.')}>Rechazar</button>}
              <button className="btn btn-outline btn-sm" onClick={() => acceso(c)}>🔑 Enviar acceso</button>
              <button className="btn btn-outline btn-sm" onClick={() => run(() => api.adminEditarComercio(c.id, { activo: !c.activo }))}>{c.activo ? 'Pausar local' : 'Reactivar local'}</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// Admin de Cupido Descuentos: los "patrocinados" salen primero y como lugar recomendado en el chat
export default function DescuentosAdmin({ success, error }) {
  const [lista, setLista] = useState([]);
  const [categorias, setCategorias] = useState(['Café']);
  const [form, setForm] = useState(VACIO);
  const [editId, setEditId] = useState(null);

  const load = useCallback(async () => {
    try { const d = await api.adminDescuentos(); setLista(d.descuentos || []); setCategorias(d.categorias || ['Café']); }
    catch (e) { error(e.message || 'Error cargando descuentos.'); }
  }, [error]);
  useEffect(() => { load(); }, [load]);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const guardar = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.adminEditarDescuento(editId, form); else await api.adminCrearDescuento(form);
      success(editId ? 'Descuento actualizado.' : 'Descuento creado.');
      setForm(VACIO); setEditId(null); load();
    } catch (err) { error(err.message); }
  };
  const editar = (d) => {
    setEditId(d.id);
    setForm({ nombre_local: d.nombre_local, categoria: d.categoria, descuento: d.descuento, descripcion: d.descripcion || '',
      direccion: d.direccion || '', condiciones: d.condiciones || '', patrocinado: !!d.patrocinado, activo: !!d.activo });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const pausar = async (d) => {
    try { await api.adminPausarDescuento(d.id, !d.pausado_admin); load(); } catch (err) { error(err.message); }
  };
  const borrar = async (d) => {
    if (!window.confirm(`¿Borrar ${d.nombre_local}? Se pierden sus códigos.`)) return;
    try { await api.adminBorrarDescuento(d.id); load(); } catch (err) { error(err.message); }
  };

  return (
    <div>
      <Locales success={success} error={error} />
      <h3 className="regalos-section-title">🏷️ Descuentos</h3>
      <form className="comercio-card" onSubmit={guardar}>
        <h3 style={{ marginBottom: 12 }}>{editId ? '✏️ Editar descuento' : '🏷️ Nuevo descuento'}</h3>
        <div className="comercio-form-grid">
          <input className="form-input" placeholder="Nombre del local" value={form.nombre_local} onChange={set('nombre_local')} />
          <select className="form-input" value={form.categoria} onChange={set('categoria')}>
            {categorias.map(c => <option key={c}>{c}</option>)}
          </select>
          <input className="form-input" placeholder="Descuento (ej: 20% en la cuenta)" value={form.descuento} onChange={set('descuento')} />
          <input className="form-input" placeholder="Dirección" value={form.direccion} onChange={set('direccion')} />
          <input className="form-input" placeholder="Descripción" value={form.descripcion} onChange={set('descripcion')} />
          <input className="form-input" placeholder="Condiciones (ej: de lunes a jueves)" value={form.condiciones} onChange={set('condiciones')} />
        </div>
        <label style={{ marginRight: 16 }}><input type="checkbox" checked={form.patrocinado} onChange={set('patrocinado')} /> 📍 Patrocinado (lugar recomendado)</label>
        <label><input type="checkbox" checked={form.activo} onChange={set('activo')} /> Activo</label>
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <button type="submit" className="btn btn-primary btn-sm">{editId ? 'Guardar cambios' : 'Crear'}</button>
          {editId && <button type="button" className="btn btn-ghost btn-sm" onClick={() => { setEditId(null); setForm(VACIO); }}>Cancelar</button>}
        </div>
      </form>

      {lista.length === 0 ? <p className="regalos-empty">Todavía no cargaste descuentos.</p> : lista.map(d => (
        <div key={d.id} className="comercio-card">
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
            <div>
              <strong>{d.nombre_local}</strong> · {d.categoria} · <span style={{ color: 'var(--dorado-claro)' }}>{d.descuento}</span>
              {d.patrocinado ? ' · 📍 Patrocinado' : ''}{!d.activo ? ' · ⏸️ Inactivo' : ''}{d.pausado_admin ? ' · ⛔ Pausado por vos' : ''}
              {d.comercio_id && <div style={{ fontSize: 13, color: 'var(--texto-muted)' }}>🏪 Lo cargó el local desde su panel ({d.comercio_nombre}{d.comercio_estado !== 'aprobado' ? `, comercio ${d.comercio_estado}` : ''})</div>}
              <div style={{ fontSize: 13, color: 'var(--texto-muted)' }}>{d.direccion} · 🎟️ {d.canjes} códigos entregados · ✅ {d.canjeados} usados en el local</div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-outline btn-sm" onClick={() => editar(d)}>Editar</button>
              <button className="btn btn-outline btn-sm" onClick={() => pausar(d)}>{d.pausado_admin ? 'Reactivar' : 'Pausar'}</button>
              <button className="btn btn-ghost btn-sm" onClick={() => borrar(d)}>Borrar</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
